import { ofType } from "redux-observable";
import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { catchError, mergeMap } from "rxjs/operators";
import { AJAX_HEADER_APP_DEFAULT } from "../../../const/common/ajaxConsts";
import { FETCH_CARRIER_PROPERTIES_URL } from "../../../const/common/endpoints";
import { convertArrayToFormSerialized } from "../../../util/common/ajaxHelper";
import { LoadCarrierProperties } from "../../actions/common/actionCreators";

export const carrierPropertiesEpic = (action$, state$, { dispatch }) =>
  action$.pipe(
    //tap(val => console.log(state$)),
    ofType(LoadCarrierProperties.REQUEST().type),
    mergeMap(val => {
      const propertyNames = val.payload.propertyNames;
      return ajax
        .post(
          FETCH_CARRIER_PROPERTIES_URL,
          {
            ...convertArrayToFormSerialized("propertyNames", propertyNames),
            carrierId:
              val.payload && val.payload.carrierId
                ? val.payload.carrierId
                : state$.value.PortalReducer.UserContextReducer.selectedAirline
                    ?.id || 0,
          },
          {
            ...AJAX_HEADER_APP_DEFAULT,
          }
        )
        .pipe(
          /* tap(val =>
            console.log(
              `carrierPropertiesEpic after ajax: ${JSON.stringify(val)}`
            )
          ), */
          mergeMap(xhrResponse => {
            //console.log(xhrResponse.response);
            return of(
              LoadCarrierProperties.SUCCESS({
                response: xhrResponse.response,
                propertyNames,
              })
            );
          }),
          catchError(error => {
            console.log(error);
            return of(LoadCarrierProperties.FAILURE());
          })
        );
    })
  );
